import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Build as BuildIcon,
  AdminPanelSettings as AdminIcon
} from '@mui/icons-material';

export const MaintenanceMode: React.FC<{ isAdmin: boolean }> = ({
  isAdmin
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      p: 4
    }}
  >
    <BuildIcon sx={{ fontSize: 80, color: '#38e8ff', mb: 2 }} />

    <Typography variant="h4" fontWeight="bold" gutterBottom>
      Marketplace Under Maintenance
    </Typography>

    <Typography
      variant="h6"
      color="text.secondary"
      sx={{ mb: 3, maxWidth: 600 }}
    >
      We're currently performing maintenance on the marketplace to improve your
      experience. Please check back soon!
    </Typography>

    {isAdmin && (
      <Box
        sx={{
          mt: 3,
          p: 3,
          backgroundColor: 'rgba(56, 232, 255, 0.1)',
          borderRadius: 2,
          border: '1px solid #38e8ff',
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}
      >
        <AdminIcon sx={{ color: '#38e8ff' }} />
        <Typography
          variant="body1"
          sx={{ color: '#38e8ff', fontWeight: 'medium' }}
        >
          Admin Access: You can still access the marketplace during maintenance
        </Typography>
      </Box>
    )}

    <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
      Thank you for your patience while we make improvements!
    </Typography>
  </Box>
);
